import React, { useState, useContext, useEffect,lazy,Suspense } from 'react'
import classNames from 'classnames'

import { Icon, Col, Row, Divider, Button, Stencil } from '@cleartrip/bento'
import logError from 'utils/logError'
import Dropdown from 'components/Dropdown'
// import UserProfileModal from './UserProfileModal'
import { dataLayerGA } from 'utils/dataLayerHelper.js'
import { getCookie, getUserAuthValues, isEmpty } from 'utils/browserHelper'
import Clevertap from 'analytics'
import { ClevertapDataContext, ProfileDataContext } from 'context/flights/results'

import { ItineraryDataContext } from 'context/itinerary'
import { ResultsDataContext } from 'context/flights/results'
import { CFW_STATUS_FLAGS, DOMAIN_COUNTRY_MAP } from 'constants/flightResults'
import { HI_FIVE_URL, DOMAIN } from 'constants/base'
import { ReactComponent as CfwLogo } from 'assets/logos/cfw.svg'
import { ReactComponent as Lock } from 'assets/icons/lock.svg'
import { ReactComponent as Cancellation } from 'assets/icons/cancellation.svg'
import { ReactComponent as ChangeFlight } from 'assets/icons/change-flight.svg'
import { ReactComponent as Profile } from 'assets/icons/profile.svg'
import { ReactComponent as PrintTicket } from 'assets/icons/print-ticket.svg'
import { ReactComponent as Trips } from 'assets/icons/trips.svg'
import { ReactComponent as Settings } from 'assets/icons/settings.svg'
import { ReactComponent as Shortlist } from 'assets/icons/shortlist.svg'
import { ReactComponent as Travellers } from 'assets/icons/travellers.svg'
import { ReactComponent as Wallet } from 'assets/icons/wallet.svg'
import { ReactComponent as Expressway } from 'assets/icons/expressway.svg'
import { ReactComponent as HiFive } from 'assets/icons/hi-five.svg'
import langTranslate from 'locale'
import { userStateApi } from 'api/flights/results'
import useModal from 'lib/Modal/useModal'
//import ViewContainer from './ViewContainer'
import USER_PROFILE_PAGE_CONTANTS from './UserProfileConstants'
import { UserProfileContext } from 'context/itinerary'

import { sendClevertapUIActionEvent as ClevertapEvent } from 'utils/globalNav/unifiedLogin'
import { triggerHiFiveClevertap } from 'components/HiFivePageModal/hiFiveClevertap'
import { formSrpSearchQuery } from 'utils/flights/results'
import { resolveKeysInObjectsArrays, isUserSignedIn } from 'utils/browserHelper'
const ViewContainer = lazy(() => import(/* webpackChunkName: "ViewContainer" */ './ViewContainer'))
const UserProfile = ({ minHeader = false, abTest = {} }) => {
    const [userProfile, setUserProfile] = useContext(ProfileDataContext)
    const [userData, setUserData] = useContext(UserProfileContext)
    const { isShowing, toggle } = useModal()
    const [page, setPage] = useState(null)
    const [resultsData] = useContext(ResultsDataContext)

    const [itineraryData] = useContext(ItineraryDataContext)
    const isRTL = process.env.CONTENT_DIR === 'RTL'
    const [signedIn, setSignedIn] = useState(false)
    const [cfwEnabled, setCfwEnabled] = useState(false)
    const [showingLoggedInMenu, setShowingLoggedInMenu] = useState(false)
    const [commonClevertapData] = useContext(ClevertapDataContext)
    // const usermisc = getCookie('usermisc') || ''
    // let { email = '', userId = '' } = getUserAuthValues()
    // if (usermisc.includes('SIGNED_IN') && !isEmpty(userId) && !signedIn) {
    //     setSignedIn(true)
    // }
    let { userId = '' } = getUserAuthValues()
    const checkUserSignedIn = () => {
        const usermisc = getCookie('usermisc') || ''
        let { email = '', userId = '' } = getUserAuthValues()
        if (usermisc.includes('SIGNED_IN') && !isEmpty(userId) && !signedIn) {
            setSignedIn(true)
        }
    }

    useEffect(() => {
        checkUserSignedIn()
    }, [userData])

    useEffect(() => {
        if (abTest && abTest['hi_five'] === 'b' && showingLoggedInMenu) {
            triggerHiFiveClevertap(
                {
                    logged_in: isUserSignedIn() ? 'yes' : 'no',
                    entry_page: 'Account',
                    platform: 'Desktop',
                    domain: resolveKeysInObjectsArrays(['location', 'hostname'], window)
                },
                'Hi5_banner_shown'
            )
        }
    }, [showingLoggedInMenu])

    const unconfirmedUser = !isEmpty(getCookie('unconfirmed-email'))

    const lock = <Lock height={16} width={16} fill="#ccc" />
    const accountItemClassName = classNames('fs-3 mx-2', {
        'c-neutral-200': unconfirmedUser || !signedIn,
        'c-neutral-900': signedIn
    })
    const hoverClassName = classNames('c-pointer flex flex-middle p-2 br-4 hover:bg-neutral-0')

    const clickableClassName = classNames('', {
        // 'c-pointer hover:td-underline': signedIn
        'c-pointer flex flex-middle p-2 br-4 hover:bg-neutral-0': signedIn
    })

    const query = resolveKeysInObjectsArrays(['location', 'pathname'], window)
    const pathname = query.split('/')
    const pagePath = pathname[2]
    const getSearchUrlParams = () => {
        const searchUrl = location.search || ''
        let params = searchUrl
        if (searchUrl.indexOf('?') > -1) {
            params = searchUrl.slice(1)
        }

        const urlParam = formSrpSearchQuery(params)
        return urlParam
    }

    let urlParam = ''

    if (pagePath === 'results') {
        urlParam = getSearchUrlParams()
    }
    const checkHiFiveFlow = () => {
        const retVal =
            pathname &&
            pathname.length > 2 &&
            pathname[1] === 'ref' &&
            !isEmpty(pathname[2]) &&
            pathname[2] != 'null' &&
            pathname[2] != 'undefined'
        return retVal
    }

    const isHiFiveFlow = checkHiFiveFlow()
    // useEffect(() => {
    //     if (
    //         !isEmpty(userProfile) &&
    //         ((isEmpty(userProfile.mobile) && isEmpty(userProfile.countryCode)) || !userProfile.mobileVerified)
    //     ) {
    //         ClevertapEvent({
    //             actionName: 'Nav_Bar_Dot_Nudge_Shown',
    //             actionType: 'Button',
    //             page:
    //                 pagePath === 'results'
    //                     ? 'SRP'
    //                     : isEmpty(pagePath)
    //                     ? 'HP'
    //                     : pathname.length > 4 && pathname[4] === 'info' && pathname[2] === 'itinerary'
    //                     ? 'Itinerary'
    //                     : 'Confirmation_Page',

    //             currentPage: pagePath,
    //             nudge_for:
    //                 isEmpty(userProfile.mobile) && isEmpty(userProfile.countryCode)
    //                     ? 'Add_Mobile_Number'
    //                     : 'Verify_Mobile_Number'
    //         })
    //     }
    // }, [userProfile])

    const handleProfileItemClick = (url, actionName, actionType) => {
        if (url === '/signout') {
            dataLayerGA({ section: 'Login' }, 'logout')
        } else {
            dataLayerGA({ clicked_option_name: actionName, section: 'Navigation' }, 'my_account_menu_clicked')
        }
        if (!isEmpty(actionName)) {
            Clevertap.event('Air_UI_Action', {
                ...commonClevertapData,
                action_type: actionType || 'Link',
                action_name: actionName,
                action_value: signedIn ? 'signed_in' : 'non_sign_in',
                ui_index: null
            })
        }
        if (signedIn) {
            setTimeout(() => {
                window.location.href = url
            }, 500)
        } else {
            window.open(url, '_blank')
        }
    }
    const handleSignedInProfileItemClick = (url, actionName, actionType) => {
        dataLayerGA({ clicked_option_name: actionName, section: 'Navigation' }, 'my_account_menu_clicked')
        if (!isEmpty(actionName)) {
            Clevertap.event('Air_UI_Action', {
                ...commonClevertapData,
                action_type: actionType || 'Link',
                action_name: actionName,
                action_value: signedIn ? 'signed_in' : 'non_sign_in',
                ui_index: null
            })
        }
        if (url.includes(HI_FIVE_URL)) {
            Clevertap.event('Air_UI_Action', {
                ...commonClevertapData,
                action_name: 'Hi5_banner_click',
                Hi5_entry_point: 'accounts',
                logged_in: signedIn ? 'yes' : 'no',
                domain: resolveKeysInObjectsArrays(['location', 'hostname'], window)
            })
        }
        if (signedIn) {
            setTimeout(() => {
                window.location.href = url
            }, 500)
        } else {
            // window.open(url, '_blank')
        }
    }

    const handleSupportClick = () => {
        dataLayerGA({ clicked_option_name: 'Support', section: 'Navigation' }, 'header_menu_click')
        let url = '/support'
        if (signedIn) {
            url = '/account/trips'
        }
        window.open(url, '_blank')
    }

    // const handleRegisterClick = () => {
    //     Clevertap.event('Air_UI_Action', {
    //         ...commonClevertapData,
    //         action_type: 'Link',
    //         action_name: 'your_trips_register',
    //         action_value: signedIn ? 'signed_in' : 'non_sign_in',
    //         ui_index: null
    //     })
    //     window.open('/register', '_blank')
    // }

    const handleUserStateHandler = async () => {
        try {
            const userResponse = await userStateApi(userId)
            const { status: userResponseStatus, data: userResponseData } = userResponse || {}

            if (userResponseStatus === 200 && !isEmpty(userResponseData)) {
                if (CFW_STATUS_FLAGS.indexOf(userResponseData) > -1) {
                    setCfwEnabled(true)
                }
            }
        } catch (e) {
            logError('User State Api Error ', e)
        }
    }

    const toggleFn = () => {
        if (userId) {
            handleUserStateHandler()
        }
    }

    const handleSignInClick = () => {
        ClevertapEvent({
            actionName: 'Nav_Bar_Login_Clicked',
            actionType: 'Button',
            page:
                pagePath === 'results'
                    ? 'SRP'
                    : isEmpty(pagePath) || isHiFiveFlow
                    ? 'HP'
                    : pathname.length > 4 && pathname[4] === 'info' && pathname[2] === 'itinerary'
                    ? 'Itinerary'
                    : 'Confirmation_Page',
            urlParam,
            resultsData,
            itineraryData,
            currentPage: pagePath
        })
        toggle()
        setPage(USER_PROFILE_PAGE_CONTANTS.SIGNIN_PAGE)
        dataLayerGA({ section: 'Login' }, 'login_clicked')
    }
    const handleVerifyClick = () => {
        ClevertapEvent({
            actionName:
                userProfile && isEmpty(userProfile.mobile) && isEmpty(userProfile.countryCode)
                    ? 'Nudge_Add_Mobile_Clicked'
                    : 'Nudge_Verify_Mobile_Clicked',
            actionType: 'Button',
            page: pagePath === 'results' ? 'SRP' : isEmpty(pagePath) || isHiFiveFlow ? 'HP' : 'Itinerary',

            currentPage: pagePath,
            nudge_position: 'Top'
        })
        toggle()
        setPage(USER_PROFILE_PAGE_CONTANTS.EMAIL_MOBILE_LINKED)
    }

    const handleSignUpClick = () => {
        ClevertapEvent({
            actionName: 'Nav_Bar_Login_Clicked',
            actionType: 'Button',
            page: pagePath === 'results' ? 'SRP' : isEmpty(pagePath) || isHiFiveFlow ? 'HP' : 'Itinerary',
            urlParam,
            resultsData,
            itineraryData,
            currentPage: pagePath
        })
        toggle()
        setPage(USER_PROFILE_PAGE_CONTANTS.SIGNUP_PAGE)
    }
    const handleIsShowing = () => {
        toggle()
    }

    const AccountOptions = (
        <Col span={12}>
            <div className="flex flex-middle">
                <Dropdown.Header className="pb-2">{langTranslate('Account')}</Dropdown.Header>
                {(unconfirmedUser || !signedIn) && lock}
            </div>
            <div className="">
                <Dropdown.Item
                    className={clickableClassName}
                    onClick={() => handleSignedInProfileItemClick('/accounts/trips', 'your_trips_trips')}
                >
                    <div className="flex flex-between flex-middle">
                        <div className="flex flex-middle">
                            <Trips height={16} width={16} className={signedIn ? 'c-neutral-400' : 'c-neutral-200'} />
                            <span className={accountItemClassName}>{langTranslate('Trips')}</span>
                        </div>
                    </div>
                </Dropdown.Item>
                {/* <Dropdown.Item
                    className={clickableClassName}
                    onClick={() => handleSignedInProfileItemClick('/account/shortlists', 'your_trips_shortlists')}
                >
                    <div className="flex flex-between flex-middle">
                        <div className="flex flex-middle">
                            <Shortlist
                                height={16}
                                width={16}
                                className={signedIn ? 'c-neutral-400' : 'c-neutral-200'}
                            />
                            <span className={accountItemClassName}>{langTranslate('Shortlists')}</span>
                        </div>
                    </div>
                </Dropdown.Item> */}
                <Dropdown.Item
                    className={clickableClassName}
                    onClick={() => handleSignedInProfileItemClick('/account/travellers', 'your_trips_travellers')}
                >
                    <div className="flex flex-between flex-middle">
                        <div className="flex flex-middle">
                            <Travellers
                                height={16}
                                width={16}
                                className={signedIn ? 'c-neutral-400' : 'c-neutral-200'}
                            />
                            <span className={accountItemClassName}>{langTranslate('Travellers')}</span>
                        </div>
                    </div>
                </Dropdown.Item>
                <Dropdown.Item
                    className={clickableClassName}
                    onClick={() => handleSignedInProfileItemClick('/accounts/wallet', 'your_trips_wallet')}
                >
                    <div className="flex flex-between flex-middle">
                        <div className="flex flex-middle">
                            <Wallet height={16} width={16} className={signedIn ? 'c-neutral-400' : 'c-neutral-200'} />
                            <span className={accountItemClassName}>{ DOMAIN_COUNTRY_MAP[DOMAIN] === 'IN' ? 'Cleartrip Wallet' : langTranslate('Wallet')}</span>
                        </div>
                    </div>
                </Dropdown.Item>
                {abTest && abTest['hi_five'] === 'b' && (
                    <Dropdown.Item
                        className={clickableClassName}
                        onClick={() => handleSignedInProfileItemClick(HI_FIVE_URL + '?src=fh', 'Hi5_banner_click')}
                    >
                        <div className="flex flex-between flex-middle">
                            <div className="flex flex-middle">
                                <HiFive
                                    height={16}
                                    width={16}
                                    className={signedIn ? 'c-neutral-400' : 'c-neutral-200'}
                                />
                                <span className={accountItemClassName}>{langTranslate('Hi-Five')}</span>
                            </div>
                        </div>
                    </Dropdown.Item>
                )}
                <Dropdown.Item
                    className={clickableClassName}
                    onClick={() => handleSignedInProfileItemClick('/accounts/expressway', 'your_trips_expressway')}
                >
                    <div className="flex flex-between flex-middle">
                        <div className="flex flex-middle">
                            <Expressway
                                height={16}
                                width={16}
                                className={signedIn ? 'c-neutral-400' : 'c-neutral-200'}
                            />
                            <span className={accountItemClassName}>{langTranslate('Expressway')}</span>
                        </div>
                    </div>
                </Dropdown.Item>
                <Dropdown.Item
                    className={clickableClassName}
                    onClick={() => handleSignedInProfileItemClick('/account/profile', 'your_trips_profile')}
                >
                    <div className="flex flex-between flex-middle">
                        <div className="flex flex-middle">
                            <Icon icon="avatar-man" height={16} width={16} fill={signedIn ? '#999' : '#ccc'} />
                            <span className={accountItemClassName}>{langTranslate('Profile')}</span>
                        </div>
                    </div>
                </Dropdown.Item>
                <Dropdown.Item
                    className={clickableClassName}
                    onClick={() => handleSignedInProfileItemClick('/account/settings','settings')}
                >
                    <div className="flex flex-between flex-middle">
                        <div className="flex flex-middle">
                            <Settings height={16} width={16} className={signedIn ? 'c-neutral-400' : 'c-neutral-200'} />
                            <span className={accountItemClassName}>{langTranslate('Settings')}</span>
                        </div>
                    </div>
                </Dropdown.Item>
            </div>
        </Col>
    )

    const QuickTools = (
        <Col span={12}>
            <Dropdown.Header className="pb-2">{langTranslate('Quick tools')}</Dropdown.Header>
            <Dropdown.Item
                className={hoverClassName}
                onClick={() => handleProfileItemClick('/accounts/trips', 'your_trips_cancellations')}
            >
                <Cancellation className="c-secondary-500" height={16} width={16} />
                <span className="fs-3 c-secondary-500 mx-2">{langTranslate('Cancellations')}</span>
            </Dropdown.Item>
            <Dropdown.Item
                className={hoverClassName}
                onClick={() => handleProfileItemClick('/accounts/trips', 'your_trips_change_flights')}
            >
                <ChangeFlight className="c-secondary-500" height={16} width={16} />
                <span className="fs-3 c-secondary-500 mx-2">{langTranslate('Change flight')}</span>
            </Dropdown.Item>
            <Dropdown.Item
                className={hoverClassName}
                onClick={() => handleProfileItemClick('/ticket', 'your_trips_print_ticket')}
            >
                <PrintTicket height={16} width={16} className="c-secondary-500" />
                <span className="fs-3 c-secondary-500 mx-2">{langTranslate('Print ticket')}</span>
            </Dropdown.Item>
            <Dropdown.Item
                className={hoverClassName}
                onClick={() => handleProfileItemClick('/voucher', 'your_trips_hotel_voucher')}
            >
                <PrintTicket height={16} width={16} className="c-secondary-500" />
                <span className="fs-3 c-secondary-500 mx-2">{langTranslate('Print hotel voucher')}</span>
            </Dropdown.Item>
        </Col>
    )
    const SignOut = (
        <>
            <Divider className="bc-neutral-100 bb bn nmx-1 my-2" />
            <div className="flex flex-right mb-2 mx-2" onClick={() => handleProfileItemClick('/signout')}>
                <span className="hover:td-underline c-error-500 fs-3 c-pointer">{langTranslate('Sign out')}</span>
            </div>
        </>
    )

    return (
        <>
            {/* need to check toggle here*/}

            {signedIn && (
                <>
                    <Dropdown overlayClassName="z-30" toggleFn={toggleFn} toggle={isShowing}>
                        <Dropdown.Select
                            border={false}
                            arrow={false}
                            label={
                                <span
                                    className="d-flex flex-middle ml-6"
                                    onClick={() => {
                                        setShowingLoggedInMenu(!showingLoggedInMenu)
                                        if (signedIn) {
                                            dataLayerGA(
                                                {
                                                    clicked_option_name: 'Nav_Bar_MyAccount_Clicked',
                                                    section: 'Navigation'
                                                },
                                                'header_menu_click'
                                            )
                                            ClevertapEvent({
                                                actionName: 'Nav_Bar_MyAccount_Clicked',
                                                actionType: 'Button',
                                                page:
                                                    pagePath === 'results'
                                                        ? 'SRP'
                                                        : isEmpty(pagePath) || isHiFiveFlow
                                                        ? 'HP'
                                                        : pathname.length > 4 &&
                                                          pathname[4] === 'info' &&
                                                          pathname[2] === 'itinerary'
                                                        ? 'Itinerary'
                                                        : 'Confirmation_Page',

                                                currentPage: pagePath,
                                                nudge_for: userProfile
                                                    ? isEmpty(userProfile.mobile) && isEmpty(userProfile.countryCode)
                                                        ? 'Add_Mobile_Number'
                                                        : 'Verify_Mobile_Number'
                                                    : 'No_nudge',
                                                Orange_dot_shown: 'No'
                                                // (!isEmpty(userProfile) &&
                                                //     (isEmpty(userProfile.mobile) &&
                                                //         isEmpty(userProfile.countryCode))) ||
                                                // !userProfile.mobileVerified
                                                //     ? 'Yes'
                                                //     :
                                            })
                                        }
                                    }}
                                >
                                    <Profile height="16px" width="16px" className="c-inherit" />
                                    <p
                                        className={classNames(
                                            'to-ellipsis o-hidden ws-nowrap c-neutral-900 fs-3 fw-500',
                                            {
                                                'mr-2': isRTL,
                                                'ml-2': !isRTL
                                            }
                                        )}
                                        style={{ maxWidth: '100px', direction: signedIn && isRTL ? 'ltr' : '' }}
                                    >
                                        {signedIn ? 'My account' : 'Log in'}
                                    </p>
                                    {/* {!isEmpty(userProfile) &&
                                        ((isEmpty(userProfile.mobile) && isEmpty(userProfile.countryCode)) ||
                                            !userProfile.mobileVerified) && (
                                            <div
                                                style={{
                                                    width: '6px',
                                                    height: '6px',
                                                    margin: '0 0 11px',
                                                    borderRadius: '4px',
                                                    backgroundColor: '#f77728'
                                                }}
                                            ></div>
                                        )} */}
                                </span>
                            }
                            className="bn p-2 nmx-2 hover:bg-neutral-0 br-4 c-neutral-400 hover:c-secondary-500"
                            width={75}
                        ></Dropdown.Select>
                        <Dropdown.Menu position={isRTL ? 'left' : 'right'} width={370} className="mt-2">
                            <Dropdown.Item className="ta-center">
                                {signedIn ? (
                                    <>
                                        <div className="fw-600 fs-3 c-neutral-900">
                                            {!isEmpty(userProfile) &&
                                            !isEmpty(userProfile.countryCode) &&
                                            !isEmpty(userProfile.mobile) ? (
                                                `${userProfile.countryCode} ${userProfile.mobile}`
                                            ) : !isEmpty(userProfile) && !isEmpty(userProfile.username) ? (
                                                `${userProfile.username}`
                                            ) : (
                                                <Stencil shimmer={true} width="346px" height="20px" />
                                            )}
                                        </div>
                                        {cfwEnabled && (
                                            <div className="pt-2">
                                                <CfwLogo />
                                            </div>
                                        )}
                                        {!isEmpty(userProfile) &&
                                            ((isEmpty(userProfile.mobile) && isEmpty(userProfile.countryCode)) ||
                                                !userProfile.mobileVerified) && (
                                                <Button
                                                    size="sm"
                                                    className="mt-1 mb-2"
                                                    // onClick={() =>
                                                    //     handleProfileItemClick('/signin', 'your_trips_sign_in', 'Button')
                                                    // }
                                                    onClick={handleVerifyClick}
                                                >
                                                    {isEmpty(userProfile.mobile) && isEmpty(userProfile.countryCode)
                                                        ? 'Add mobile number'
                                                        : 'Verify mobile number'}
                                                </Button>
                                            )}
                                    </>
                                ) : (
                                    <>
                                        <div className="pt-2">
                                            <Button
                                                type="secondary"
                                                size="sm"
                                                className="h-10"
                                                // onClick={() =>
                                                //     handleProfileItemClick('/signin', 'your_trips_sign_in', 'Button')
                                                // }
                                                onClick={handleSignInClick}
                                            >
                                                {langTranslate('Log in / Sign up')}
                                            </Button>
                                        </div>
                                    </>
                                )}
                            </Dropdown.Item>
                            <Divider className="bn bb bc-neutral-100 nmx-1 mb-2 mt-1" />
                            <Row>
                                {AccountOptions}
                                {QuickTools}
                            </Row>
                            {signedIn && SignOut}
                        </Dropdown.Menu>
                    </Dropdown>
                    <Suspense fallback={<></>}>
                    <ViewContainer
                        page={page}
                        isShowing={isShowing}
                        toggle={toggle}
                        handleIsShowing={handleIsShowing}
                        abLogin={abTest?.login_init}
                        abInline={abTest?.inlineLogin_nudge}
                    />
                </Suspense>
                    
                </>
            )}
            {!signedIn && (
                <>
                    <div className="d-flex c-pointer">
                        <Button
                            type="secondary"
                            className="h-10 br-6"
                            size="sm"
                            // onClick={() =>
                            //     handleProfileItemClick('/signin', 'your_trips_sign_in', 'Button')
                            // }
                            onClick={handleSignInClick}
                        >
                            {langTranslate('Log in / Sign up')}
                        </Button>
                    </div>
                    <Suspense fallback={<></>}>
                    <ViewContainer
                        page={page}
                        isShowing={isShowing}
                        toggle={toggle}
                        handleIsShowing={handleIsShowing}
                        abLogin={abTest?.login_init}
                        abInline={abTest?.inlineLogin_nudge}

                    />
                </Suspense>
                    
                </>
            )}
        </>
    )
}

export default UserProfile
